'use client';

import { useEffect } from 'react';

const AUTH_ERROR_PATTERNS = [
  'AuthSessionMissing',
  'Auth session missing',
  'JWT expired',
  'Invalid Refresh Token',
  'refresh_token_not_found',
];

function isAuthError(error: Error & { digest?: string }): boolean {
  const message = `${error.name ?? ''} ${error.message ?? ''}`;
  return AUTH_ERROR_PATTERNS.some((pattern) => message.includes(pattern));
}

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  // If the crash looks auth-related, the user's session is stale —
  // bounce them to /login rather than show a generic error screen.
  useEffect(() => {
    if (isAuthError(error) && typeof window !== 'undefined') {
      window.location.replace('/login');
    }
  }, [error]);

  return (
    <html lang="en">
      <body>
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <h2>Something went wrong</h2>
          <button onClick={() => reset()} style={{ marginTop: '1rem' }}>
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
